var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsBattryQution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_4629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3435 6.75H3.87673C2.69354 6.75 1.73438 7.70909 1.73438 8.89219V15.1078C1.73438 16.2909 2.69354 17.25 3.87673 17.25H18.3435C19.5267 17.25 20.4858 16.2909 20.4858 15.1078V8.89219C20.4858 7.70909 19.5267 6.75 18.3435 6.75Z",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 10.25V13.7497",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1854 13.4308V13.2108C10.1854 12.9335 10.2254 12.7015 10.3054 12.5148C10.3854 12.3281 10.488 12.1708 10.6134 12.0428C10.7387 11.9121 10.8654 11.7921 10.9934 11.6828C11.148 11.5495 11.284 11.4135 11.4014 11.2748C11.5187 11.1361 11.5774 10.9561 11.5774 10.7348C11.5774 10.5081 11.5 10.3188 11.3454 10.1668C11.1907 10.0148 10.9667 9.93881 10.6734 9.93881C10.34 9.93881 10.0827 10.0335 9.90138 10.2228C9.72004 10.4095 9.62938 10.6601 9.62938 10.9748H8.84538C8.84538 10.6121 8.92138 10.2975 9.07338 10.0308C9.22538 9.76148 9.43871 9.55348 9.71338 9.40681C9.98804 9.26015 10.308 9.18681 10.6734 9.18681C11.0414 9.18681 11.352 9.25615 11.6054 9.39481C11.8587 9.53081 12.0507 9.71615 12.1814 9.95081C12.3147 10.1855 12.3814 10.4481 12.3814 10.7388C12.3814 10.9735 12.344 11.1708 12.2694 11.3308C12.1974 11.4908 12.104 11.6308 11.9894 11.7508C11.8774 11.8681 11.7614 11.9788 11.6414 12.0828C11.5294 12.1788 11.4227 12.2788 11.3214 12.3828C11.2227 12.4868 11.1414 12.6055 11.0774 12.7388C11.016 12.8721 10.9854 13.0321 10.9854 13.2188V13.4308H10.1854ZM10.5774 14.9868C10.412 14.9868 10.272 14.9295 10.1574 14.8148C10.0454 14.7001 9.98938 14.5641 9.98938 14.4068C9.98938 14.2521 10.0454 14.1161 10.1574 13.9988C10.272 13.8815 10.412 13.8228 10.5774 13.8228C10.7427 13.8228 10.8827 13.8815 10.9974 13.9988C11.112 14.1161 11.1694 14.2521 11.1694 14.4068C11.1694 14.5641 11.112 14.7001 10.9974 14.8148C10.8827 14.9295 10.7427 14.9868 10.5774 14.9868Z",
    fill: "#9C4900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_4629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0019,
    height: 24,
    fill: "white",
    transform: "translate(0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBattryQution);
export default __webpack_public_path__ + "static/media/Details_battry_qution.8fefed734a8f42db5f3b555fa39c826d.svg";
export { ForwardRef as ReactComponent };